import { useEffect } from 'react';

import { useAppApolloClient } from '../../../../front/src/hooks/useAppApolloClient';
import { useConnectedRouter } from '../../../../front/src/hooks/useConnectedRouter';
import { usePermissions } from '../../../../front/src/hooks/usePermissions';
import { useAppDispatch } from '../../../../front/src/redux/hooks';
import { openChatWindow } from '../../../../front/src/redux/slices/chat-service';
import { objectKeyRemove } from '../../utils/objects';

export function useOpenChatFromUrl() {
  const client = useAppApolloClient();
  const dispatch = useAppDispatch();
  const { query, replace } = useConnectedRouter();
  const { isAuthDone } = usePermissions();

  useEffect(() => {
    // Opening the chat from the URL param should happen when a threadId appears in the URL.
    // Use case: opening the app from a web push notification related to a chat event, which URL brings the related chat thread ID we should open when opening that URL.
    if (!isAuthDone) {
      console.log('useOpenChatFromUrl ~ waiting for auth to be done');
      return;
    }

    let threadId = query.ct;
    if (Array.isArray(threadId)) threadId = threadId[0];

    if (!threadId) return;

    openChatWindow(client, { threadId })(dispatch);

    // Remove the ct parameter from the URL
    // so that the chat is not opened again when the user navigates away and comes back to the app
    const updatedQuery = objectKeyRemove(query, 'ct');
    replace({ query: updatedQuery }, undefined, { shallow: true });
  }, [client, dispatch, isAuthDone, query, replace]);
}
